import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=19f950ef&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f950ef')) {
      api.createRecord('19f950ef', component.options)
    } else {
      api.reload('19f950ef', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=19f950ef&", function () {
      api.rerender('19f950ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/profile.vue"
export default component.exports